import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPaginationProductRequest,
  fetchPutPromotionToProductRequest,
} from "../../../../redux/ActionCreators/ProductActionCreators";
import toArrayImageFromImageRegex from "shared/func/toArrayImageFromImageRegex";
import Checkbox from "@material-ui/core/Checkbox";
import { fetchListPromotionRequest } from "redux/ActionCreators/PromotionActionCreators";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const columns = [
  { id: "id", label: "id", minWidth: 50 },
  { id: "name", label: "Tên", minWidth: 170 },
  { id: "code", label: "Ảnh", minWidth: 100 },
  {
    id: "population",
    label: "Giá",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "size",
    label: "Giá Khuyến mãi",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "density",
    label: "Action",
    minWidth: 170,
    align: "center",
    format: (value) => value.toFixed(2),
  },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 500,
  },
});

function SaleListPage(props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [arrayCheckProduct, setArrayCheckProduct] = useState([]);
  const [promotion, setPromotion] = useState(0);

  const classes = useStyles();
  const dispatch = useDispatch();
  const products = useSelector((state) => state.products.list);
  const promotions = useSelector((state) => state.promotions.list);

  useEffect(() => {
    dispatch(fetchPaginationProductRequest(0, rowsPerPage, "", "", "", ""));
    dispatch(fetchListPromotionRequest());
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(
      fetchPaginationProductRequest(newPage, rowsPerPage, "", "", "", "")
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    dispatch(
      fetchPaginationProductRequest(0, event.target.value, "", "", "", "")
    );
  };

  const handleChangeCheck = (event) => {
    const id = event.target.name;
    if (!arrayCheckProduct.find((item) => item === id)) {
      setArrayCheckProduct([...arrayCheckProduct, id]);
    }
  };

  const handleSub = () => {
    const arrayCheckProductInt = arrayCheckProduct.map((item) =>
      parseInt(item)
    );
    dispatch(
      fetchPutPromotionToProductRequest(
        arrayCheckProductInt,
        parseInt(promotion)
      )
    );
  };

  const handleChangePromotion = (event) => {
    setPromotion(event.target.name);
  };

  return (
    <Paper>
      {promotions &&
        promotions.map((item, index) => {
          return (
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handleChangePromotion}
                  inputProps={{ "aria-label": "primary checkbox" }}
                  name={`${item.id}`}
                  key={index}
                />
              }
              label={item.name}
            />
          );
        })}
      <Button onClick={handleSub}>Handle</Button>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {products.data &&
              products.data.map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell width="100px">
                      <img
                        src={toArrayImageFromImageRegex(row.imageRegex)[0]}
                        alt="Not Found"
                      />
                    </TableCell>
                    <TableCell align="center">{row.price}</TableCell>
                    <TableCell align="center">{row.priceDiscount}</TableCell>

                    <TableCell>
                      <Checkbox
                        checked={arrayCheckProduct.find(
                          (item) => item === row.id
                        )}
                        onChange={handleChangeCheck}
                        inputProps={{ "aria-label": "primary checkbox" }}
                        name={`${row.id}`}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={products.total ? products.total : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

SaleListPage.propTypes = {};

export default SaleListPage;
